export default "__VITE_ASSET__DpFNlOJf__"